// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useMemo, useState } from "react";
import { Stack, useMediaQuery, useTheme } from "@mui/material";
import {
  GridColDef,
  GridPaginationModel,
  GridActionsCellItem,
  GridRowId,
} from "@mui/x-data-grid";
import { DeleteConfirmModal, Table } from "../../molecules";
import {
  DeleteMenuRequest,
  IChangeRequest,
  useAuthorization,
  useDeleteMenu,
  useGetChangeRequestList,
  useGetSendApprovedChangeRequestList,
} from "../../../hooks";
import { ApprovalBar, ApprovalSubmitedBar, Loading } from "../../atoms";
import { useSetSnackBar } from "../../../store/Snackbar.state";
import { downloadExcel } from "../../../util/downloadExcel";
import { useUserInfo } from "../../../store/User.state";
import dayjs from "dayjs";
import screenNames from "../../../common/screenNames.json";

function RenderStatus(props: GridRenderCellParams<any, string>) {
  const { value } = props;

  return <>{value && <ApprovalSubmitedBar status={value} />}</>;
}

export type TransactionSubmittedForApprovalListingTableProps = {
  onRowClick?: (data: { id: GridRowId; row: IChangeRequest }) => void;
  isMenuOpen?: boolean;
};

export const TransactionSubmittedForApprovalListingTable = ({
  onRowClick,
  isMenuOpen,
}: TransactionSubmittedForApprovalListingTableProps) => {
  const theme = useTheme();
  const { showDelete, showUpdate } = useAuthorization();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const [queryOptions, setQueryOptions] = React.useState({});
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: -1,
  });
  const {
    data,
    mutate: getSendApprovedChangeRequestList,
    isLoading,
  } = useGetSendApprovedChangeRequestList();
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(0);
  const setSnackbar = useSetSnackBar();
  const { mutate: menuDelete, isLoading: isDeleteLoading } = useDeleteMenu();
  // const tableData = data?.data;
  const [tableData, setTableData] = useState<PagingResponse<Array<any>>>();
  const [shouldRefresh, setShouldRefresh] = React.useState(false);
  const [userInfo] = useUserInfo();

  useEffect(() => {
    if (!isMenuOpen) {
      const requestPayload = {
        roleLevel: +userInfo?.level,
        makerUserId: +userInfo?.userId,
        ...getQueryParams(queryOptions),
      };

    if (queryOptions?.field && queryOptions?.value !== undefined) {
      requestPayload[queryOptions.field] = queryOptions.value;
    }

    getSendApprovedChangeRequestList(requestPayload, {
      onSuccess: (data) => {
        if (data?.isSuccess) {
          setTableData(data?.data);
        } else {
          setSnackbar({
            severity: "error",
            description: data.message,
            isOpen: true,
          });
        }
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      },
    });
  }}, [
    getSendApprovedChangeRequestList,
    paginationModel?.page,
    paginationModel?.pageSize,
    setSnackbar,
    queryOptions,
    shouldRefresh,
    isMenuOpen,
  ]);

  const handleChangePagination = (model: GridPaginationModel) => {
    setPaginationModel(model);
    setTableData(undefined);
    getSendApprovedChangeRequestList(
      {
        roleLevel: +userInfo.level,
        makerUserId: +userInfo.userId,
      },
      {
        onSuccess: (data) => {
          if (data.isSuccess) {
            setTableData(data?.data);
          } else {
            setSnackbar({
              severity: "error",
              description: data.message,
              isOpen: true,
            });
          }
        },
        onError: () => {
          setSnackbar({
            severity: "error",
            description: "İşlem sırasında bir hata oluştu",
            isOpen: true,
          });
        },
      }
    );
  };

  const deleteRow = React.useCallback(
    (menu: IChangeRequest) => () => {
      setIsDeleteModalOpen(true);
      setSelectedRowId(Number(menu.id));
    },
    []
  );

  const handleCloseDeleteModal = () => {
    setIsDeleteModalOpen(false);
  };

  const handleDeleteConfirm = () => {
    const deleteRequest: DeleteMenuRequest = { id: selectedRowId };

    menuDelete(deleteRequest, {
      onSuccess: (data: any) => {
        if (data.isSuccess) {
          setShouldRefresh((prevState) => !prevState);
          setSnackbar({
            severity: "success",
            isOpen: true,
            description: data.message,
          });
        } else {
          setSnackbar({
            severity: "error",
            description: data.message,
            isOpen: true,
          });
        }
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      },
    });

    handleCloseDeleteModal();
  };
  function translateOperationMode(mode: string) {
    switch (mode) {
      case "UPDATE":
        return "Güncelleme";
      case "DELETE":
        return "Silme";
      case "ADD":
        return "Tanımlama";
        case "SendMoney":
          return "Para Gönderme";
      default:
        return "Bilinmiyor";
    }
  }

  function transformStatus(mode: string) {
    switch (mode) {
      case "APPROVED":
        return "ONAYLANDI";
      case "REJECTED":
        return "REDDEDİLDİ";
      case "PENDING":
        return "ONAYA GÖNDERİLDİ";
      default:
        return "Bilinmiyor";
    }
  }

  const columns: GridColDef[] = useMemo(() => {
    return [
      // {
      //   field: "actions",
      //   type: "actions",
      //   width: 80,
      //   getActions: (params) => [
      //     !!showDelete ? (
      //       <GridActionsCellItem
      //         label="Sil"
      //         onClick={deleteRow(params.row)}
      //         showInMenu
      //       />
      //     ) : (
      //       <></>
      //     ),
      //   ],
      // },

      {
        field: "operationCode",
        headerName: "Ekran Adı",
        width: 300,
        valueGetter: (params) => screenNames[params.value] || params.value,
      },
      {
        field: "operationMode",
        headerName: "İşlem Tipi",
        width: 300,
        filterable: false,
        renderCell: (params) => {
          const operation = params.value as string;
          return translateOperationMode(operation);
        },
      },

      {
        field: "createDate",
        headerName: "Onaya Gönderme Tarihi",
        width: 300,
        renderCell: (params) => {
          if (!params.value) return "";
          const formattedDate = dayjs(params.value).format("DD.MM.YYYY HH:mm");
          if (formattedDate === "Invalid Date") return "";
          return formattedDate;
        },
      },
      {
        field: "updateDate",
        headerName: "Onay/Red Tarihi",
        width: 250,
        renderCell: (params) => {
          if (!params.value) return "";
          const formattedDate = dayjs(params.value).format("DD.MM.YYYY HH:mm");
          if (formattedDate === "Invalid Date") return "";
          return formattedDate;
        },
      },
      {
        field: "checkerUserName",
        headerName: "Onaylayan/Reddeden Kullanıcı",
        width: 300,
      },
      {
        renderCell: RenderStatus,
        field: "status",
        headerName: "Durum",
        width: 300,
        filterable: false,
      },
      {
        field: "rejectReason",
        headerName: "Red Nedeni",
        width: 300,
        filterable: false,
      },
    ];
  }, [deleteRow, showDelete]);

  const translateScreenName=(code)=>{
    return screenNames[code] || code
  }

  const onSave = () => {
    const requestPayload = {
      roleLevel: +userInfo.level,
      makerUserId: +userInfo.userId,
      // size: -1,
      // page: 0,
      // orderBy: "CreateDate",
      // orderByDesc: true,
      ...getQueryParams(queryOptions),
    };

    if (queryOptions?.field && queryOptions?.value !== undefined) {
      requestPayload[queryOptions.field] = queryOptions.value;
    }

    getSendApprovedChangeRequestList(requestPayload, {
      onSuccess: (data) => {
        if (data.isSuccess) {
          function fieldValue(data) {
            return data.map((item) => {
              return {
                "Ekran Adı": translateScreenName(item?.operationCode),
                "İşlem Tipi": translateOperationMode(item?.operationMode),
                "Onaya Gönderme Tarihi": dayjs(item?.createDate).format(
                  "DD.MM.YYYY HH:mm"
                ),
                "Onay/Red Tarihi": dayjs(item?.updateDate).format(
                  "DD.MM.YYYY HH:mm"
                ),
                "Onaylayan/Reddeden Kullanıcı": item?.checkerUserName,
                "Durum": transformStatus(item?.status),
                "Red Nedeni": item?.rejectReason,
              };
            });
          }
          const refactoredData = fieldValue(data?.data);
          downloadExcel(refactoredData || [], "Onaya Gönderdiklerim Listesi");
        } else {
          setSnackbar({
            severity: "error",
            description: data.message,
            isOpen: true,
          });
        }
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      },
    });
  };
  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func.apply(null, args);
      }, delay);
    };
  };

  const getQueryParams = (filters) => {
    const queryParams = {};

    for (let key in filters) {
      if (filters[key]?.toString()?.length >= 1) {
        queryParams[key] = filters[key];
      }
    }

    return queryParams;
  };

  const handleFilterChange = debounce((filters) => {
    if (filters.clearFilter) {
      return setQueryOptions({});
    }

    const queryParams = getQueryParams(filters);

    const allValuesAtLeastThreeChars = Object.values(queryParams).every(
      (value) => value?.toString().length >= 3
    );
    const atLeastOneValueThreeChars = Object.values(queryParams).some(
      (value) => value?.toString().length >= 3
    );

    const previousKeysLength = Object.keys(previousQueryParams.current).length;
    const currentKeysLength = Object.keys(queryParams).length;

    // Eğer queryParams bir önceki ile aynıysa işlem yapma
    if (
      JSON.stringify(previousQueryParams.current) ===
      JSON.stringify(queryParams)
    ) {
      return;
    }

    if (
      allValuesAtLeastThreeChars ||
      (atLeastOneValueThreeChars && previousKeysLength > currentKeysLength)
    ) {
      setQueryOptions(queryParams);
    }

    // Son olarak, mevcut queryParams değerini bir önceki değer olarak set edin
    previousQueryParams.current = queryParams;
  }, 500);

  // Komponent içerisinde
  const previousQueryParams = React.useRef({});
  const hasActiveFilters = Object?.keys(queryOptions)?.length > 0;
  const hasLoading = isLoading || isDeleteLoading;

  return (
    <>
      {hasLoading && <Loading />}
      <Stack flex={1} p={2}>
        <>
          <Table
            columnVisibilityConfigKey="TransactionSubmittedForApprovalListingTableKey"
            hasActiveFilters={hasActiveFilters}
            handleFilterChange={handleFilterChange}
            paginationModel={paginationModel}
            onPaginationModelChange={handleChangePagination}
            paginationMode="server"
            rowCount={tableData?.length || 0}
            sx={{ width: isDesktop ? 1308 : window.innerWidth - 50 }}
            isRowSelectable={() => false}
            onRowClick={!!showUpdate ? onRowClick : () => null}
            // disableColumnMenu
            rows={tableData || 0}
            columns={columns}
            className="myTable"
            customLabelDisplayedRows={true}
            exportFileName="Onaya Gönderdiklerim Listesi"
            onSave={() => onSave()}
          />
          <DeleteConfirmModal
            isOpen={isDeleteModalOpen}
            onClose={handleCloseDeleteModal}
            onConfirm={() => handleDeleteConfirm()}
          ></DeleteConfirmModal>
        </>
      </Stack>
    </>
  );
};
